import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DEACTIVATED, REMOVED } from '../constants/activation-status';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ActivationStatusTag = styled.div.withConfig({
  displayName: "OwnerActivationStatusTag__ActivationStatusTag",
  componentId: "sc-2d73k9-0"
})(["display:inline-block;"]);
const OwnerActivationStatusTag = ({
  activationStatus
}) => {
  switch (activationStatus) {
    case DEACTIVATED:
      return /*#__PURE__*/_jsx(ActivationStatusTag, {
        children: /*#__PURE__*/_jsx(Text, {
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "routing-ui.reassignment.activationStatusDeactivated"
          })
        })
      });
    case REMOVED:
      return /*#__PURE__*/_jsx(ActivationStatusTag, {
        children: /*#__PURE__*/_jsx(Text, {
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "routing-ui.reassignment.activationStatusRemoved"
          })
        })
      });
    default:
      return null;
  }
};
OwnerActivationStatusTag.displayName = 'OwnerActivationStatusTag';
export default OwnerActivationStatusTag;